import type { BtnListConfig, HeadBtnListConfig } from 'liyu-pc-base/api/typing';
export const btn_list: BtnListConfig = [];
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list: HeadBtnListConfig = [];
